import scrollingText from './scrollingText';

const announcementBar = () => {
  const announcementBar = $('.mrAnnouncement-container');
  const announcementBarWrap = $('.mrAnnouncement-content-wrap');

  $('.mrAnnouncement-close-button').click(() => {
    $('#shopify-section-announcement-bar').css('height', 0).css('opacity', 0);
    $('.mrAnnouncement-container').remove();
  });

  // the mobile bar grows to fit up to three lines, so publish its real height
  // for anything laid out around it (e.g. the mobile menu drawer)
  const setAnnouncementBarHeight = () => {
    if (announcementBar.length) {
      document.documentElement.style.setProperty(
        '--announcement-bar-height',
        `${announcementBar.outerHeight()}px`,
      );
    }
  };

  if (announcementBar.attr('data-carousel-swicher') == 'true') {
    initialAnnouncementBar(announcementBarWrap);
  } else if (
    announcementBar.attr('data-scrolling-swicher') == 'true' &&
    announcementBar.attr('data-single-announcement') > 1
  ) {
    if ($(window).width() <= 768) {
      scrollingText(announcementBarWrap, 10, 5);
    } else {
      scrollingText(announcementBarWrap, 1, 15);
    }
  }

  setAnnouncementBarHeight();
  $(window).on('resize', setAnnouncementBarHeight);

  /**
   * initialAnnouncementBar
   * this function will check if there are any 'announcement bar contents'
   * if so, will apply slider logic based on the window size
   */
  function initialAnnouncementBar(announcementEle) {
    if (announcementEle) {
      const autoplaySpeed = parseInt(announcementBar.attr('data-autoplay-speed'), 10) || 2000;
      let settings = {
        arrows: false,
        dots: false,
        draggable: false,
        autoplay: true,
        autoplaySpeed,
        fade: true,
        infinite: true,
        cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
      };
      if ($(window).width() <= 768) {
        settings = {
          arrows: true,
          dots: false,
          draggable: true,
          autoplay: true,
          autoplaySpeed,
          fade: true,
          infinite: true,
          cssEase: 'cubic-bezier(0.7, 0, 0.3, 1)',
        };
      }
      announcementEle.slick(settings);
    }
  }
};

export default announcementBar;
